import UITitle from "../atoms/UITitle";
import UIStepsCard from "../molecules/UIStepsCard";

export default function UISteps() {
    return (
        <section className="px-[10%] pb-[68px] pt-[54px] bg-[#F7F7F7] flex flex-col justify-center items-center">
            <UITitle style={{ color: "#2D2D2D" }} h3 className="text-center md:text-left px-[4%] md:p-0 text-[25px] md:text-[30px] font-BNPPSquareBold mb-[64px]">¿Qué debo tener en cuenta para registrarme?</UITitle>
            <div className="flex flex-col lg:flex-row gap-[40px]">
                <UIStepsCard
                    index={1}
                    thumbnail='/assets/images/img_steps_1.webp'
                    title="Ten activo tu seguro"
                    description="Para acceder a los servicios digitales debes tener un seguro activo."
                    color='#a375c9'
                />
                <UIStepsCard
                    index={2}
                    thumbnail='/assets/images/img_steps_2.webp'
                    title="Registra tus datos"
                    description="Haz clic en el botón “Regístrate” y diligencia un sencillo formulario con tus datos personales."
                    color="#ffc476"
                />
                <UIStepsCard
                    index={3}
                    thumbnail='/assets/images/img_steps_3.webp'
                    title="Utiliza tus beneficios"
                    description="Comienza a hacer uso de tus servicios personalizados que se activarán de acuerdo con el tipo y cobertura de tu seguro."
                    color="#ff91a1"
                />
            </div>
        </section>
    )
}